export const MANAGEMENT_SIGNALS_API_INTEGRATION_SUBSCRIBED_DOMAINS_URL =
    "management:signals-api-integration-subscribed-domains-url";
